import React from 'react';
import InputCta from './InputCta';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { Section, Grid, GridItem, Box, Typography, Image } from '@miro-site/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FooterSectionBox = styled(Box, {
  '.svg-wrapper': {
    position: 'absolute',
    zIndex: '1',
    right: '0',
    top: '0',
    width: '50%'
  },
  '.logo-wrapper': {
    display: 'inline-block'
  }
});
var LogoInputWrapper = styled(Primitive.div, {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '$600',
  width: '100%',
  '.input-wrapper': {
    marginLeft: '0',
    display: 'flex',
    flexDirection: 'column',
    '.button-wrapper': {
      margin: '0 auto'
    },
    input: {
      height: '46px',
      maxWidth: '270px',
      margin: '0 auto $200 auto'
    },
    '@md': {
      flexDirection: 'row',
      input: {
        maxWidth: 'initial',
        margin: '0 $200 0 0'
      }
    }
  }
});

var FooterSection = function FooterSection(props) {
  var _props$logos;

  return /*#__PURE__*/_jsx(Section, {
    backgroundColor: "$indigo-90",
    css: {
      position: 'relative',
      overflow: 'hidden',
      marginTop: '$800',
      paddingY: '$600',
      '@md': {
        marginTop: '$1200'
      },
      '@lg': {
        paddingY: '$800'
      },
      '@xl': {
        marginTop: '$1600'
      }
    },
    children: /*#__PURE__*/_jsxs(FooterSectionBox, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "svg-wrapper",
        children: /*#__PURE__*/_jsx("svg", {
          width: "705",
          height: "505",
          viewBox: "0 0 705 505",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: /*#__PURE__*/_jsx("path", {
            d: "M617 120V-245L810 -244.997L727.286 99.3396L617 120ZM219.999 217.143L112.021 235L0 -185L220 -184.967L219.999 217.143ZM150 271.128L240.818 650L343 649.965V261.528L449.183 243.536L558.487 652L670 651.966V183L557 201.632V-114H377.657H366H293V245.1L150 271.128Z",
            fill: "#FF6575"
          })
        })
      }), /*#__PURE__*/_jsxs(Grid, {
        css: {
          position: 'relative',
          zIndex: '2',
          gridRowGap: '0'
        },
        children: [/*#__PURE__*/_jsxs(GridItem, {
          xs: 12,
          columnStart: {
            '@sm': '2',
            '@md': '3',
            '@lg': '1'
          },
          columnEnd: {
            '@sm': 12,
            '@md': '11',
            '@lg': '6',
            '@xl': '5'
          },
          css: {
            textAlign: 'center',
            '@md': {
              gridColumnStart: '3'
            },
            '@lg': {
              textAlign: 'left',
              gridColumnStart: '1'
            }
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            color: "tertiary",
            variant: "heading-2",
            offsetBottom: "300",
            children: props === null || props === void 0 ? void 0 : props.title
          }), /*#__PURE__*/_jsx(Typography, {
            color: "tertiary",
            variant: "body-text-1",
            offsetBottom: "400",
            children: props === null || props === void 0 ? void 0 : props.content
          })]
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          columnStart: {
            '@sm': '2',
            '@md': '3',
            '@lg': '1'
          },
          columnEnd: {
            '@sm': 12,
            '@md': '11',
            '@lg': '6',
            '@xl': '5'
          },
          css: {
            textAlign: 'center',
            '@md': {
              gridColumnStart: '3'
            },
            //Above columnStart property is not working as expected(In md, sm values are applied), so overiding again in css
            '@lg': {
              textAlign: 'left',
              gridColumnStart: '1'
            }
          },
          children: /*#__PURE__*/_jsx(LogoInputWrapper, {
            children: /*#__PURE__*/_jsx("div", {
              className: "input-wrapper",
              children: /*#__PURE__*/_jsx(InputCta, {
                cta: props === null || props === void 0 ? void 0 : props.cta,
                placeholder: props === null || props === void 0 ? void 0 : props.inputPlaceHolder
              })
            })
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          columnStart: {
            '@sm': '2',
            '@md': '3',
            '@lg': '1'
          },
          columnEnd: {
            '@sm': 12,
            '@md': '11',
            '@lg': '-1'
          },
          css: {
            '@md': {
              gridColumnStart: '3'
            },
            '@lg': {
              gridColumnStart: '1'
            }
          },
          children: /*#__PURE__*/_jsx("div", {
            children: props === null || props === void 0 ? void 0 : (_props$logos = props.logos) === null || _props$logos === void 0 ? void 0 : _props$logos.map(function (logo, index) {
              var _logo$logo;

              return /*#__PURE__*/_jsx("div", {
                className: "logo-wrapper",
                children: /*#__PURE__*/_jsx(Image, {
                  image: logo === null || logo === void 0 ? void 0 : (_logo$logo = logo.logo) === null || _logo$logo === void 0 ? void 0 : _logo$logo.desktop
                }, "footer-logo-".concat(index))
              });
            })
          })
        })]
      })]
    })
  });
};

export default FooterSection;